import React from 'react';

interface ModuleViewContainerProps {
  children: React.ReactNode;
  className?: string;
  /** Inner padding. Defaults to a comfortable card-like spacing. */
  padding?: string;
}

/**
 * Outer card for every learner module view (mode='learner').
 *
 * - Fills the parent's width — the learner page already caps the column to
 *   80% / 90% (mobile), so this wrapper deliberately does NOT impose its
 *   own width cap.
 * - Background uses the project gradient asset at 20% opacity (per Figma
 *   "Tereiko Gradient 20%"), with light/dark variants pulled from
 *   `public/gradients/light.png` and `public/gradients/dark.png`.
 * - Drop shadow + 16px radius matches Figma 9140:133832.
 *
 * Preview mode renders bare without this wrapper so the Course Preview
 * Overlay's own chrome isn't double-padded.
 */
const ModuleViewContainer: React.FC<ModuleViewContainerProps> = ({
  children,
  className,
  padding = 'p-5 sm:p-7',
}) => {

  return (
    <div
      className={`relative w-full flex-1 flex flex-col min-h-0 rounded-2xl overflow-hidden ${className ?? ''}`}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
            aria-hidden="true"
            className="brand-gradient absolute inset-0 opacity-40"
          />
      </div>
      <div className={`relative flex-1 flex flex-col min-h-0 ${padding}`}>{children}</div>
    </div>
  );
};

export default ModuleViewContainer;
